import { render, staticRenderFns } from "./InvoiceHistory.vue?vue&type=template&id=38597e5d&scoped=true&"
import script from "./InvoiceHistory.vue?vue&type=script&lang=ts&"
export * from "./InvoiceHistory.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceHistory.vue?vue&type=style&index=0&id=38597e5d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38597e5d",
  null
  
)

export default component.exports